import cx from 'classnames';
import { intcomma } from 'journalize';
import { h, VNode } from 'preact';

import PureComponent from './PureComponent';

import formatPercent from '../utils/format-percent';
import { isCanvass } from '../endpoints';
import PartyPill from './PartyPill';

interface Props {
  ballotName: string;
  candidateId: string;
  contestIsCalled: boolean;
  contestResult: string;
  isIncumbent: boolean;
  isWinner: boolean;
  numDelegates: any | null;
  candidateColors: { [key: string]: any };
  party: string;
  totalVotesInContest: number;
  votes: number;
}

class HeadshotCandidateRow extends PureComponent<Props> {
  static columnCount: number;
  static Header: VNode;
  static Header_Prez: VNode;

  render() {
    const {
      ballotName,
      candidateId,
      contestIsCalled,
      contestResult,
      isIncumbent,
      isWinner,
      party,
      isViewable,
      office,
      numDelegates,
      totalVotesInContest,
      candidateColors,
      votes,
    } = this.props;

    let getColor;


    if (candidateColors && party == 'Republican' && office == 'President') {
      getColor = totalVotesInContest > 0 ? candidateColors
        .filter(obj => obj.name == ballotName)
        .map(obj => obj.color) : ['#EF564A'];
    } else if (candidateColors && party == 'Democrat' && office == 'U.S. Senate') {
      getColor = totalVotesInContest > 0 ? candidateColors
        .filter(obj => obj.name == ballotName)
        .map(obj => obj.color) : ['#1755c5'];
    } else if (candidateColors && party == 'Republican' && office == 'U.S. Senate') {
      getColor = ['#EF564A']
    }
    else {
      getColor = ['#1755c5']
    }

    const divStyle = {
      'background-color': getColor[0],
    };

    const checkStyle = {
      color: getColor[0],
    };

    const IsAsterisk =
      ballotName == 'Chris Christie' ||
      ballotName == 'Vivek Ramaswamy' ||
      ballotName == 'Asa Hutchinson' ||
      ballotName == 'Ron DeSantis' ||
      ballotName == 'Marianne Williamson'
        ? true
        : false;

    let rowClass = cx(
      'candidate',
      'contest__candidate-row',
      'contest__candidate-row--headshot',
      {
        'contest__candidate-row--winner dem--border':
          contestIsCalled && isWinner && party == 'Democrat',
        'contest__candidate-row--winner rep--border':
          contestIsCalled && isWinner && party == 'Republican',
      }
    );

    let checkClass = cx('check', {
      'dem-winner': party == 'Democrat',
      'rep-winner': party == 'Republican',
      'runoff-winner': contestResult == 'runoff',
    });

    if (!isViewable) {
      rowClass += ' race__candidate-row--hidden';
    }

    const checkmark = '\u2713';

    return (
      <tr class={rowClass}>
        <td class="candidate__cell candidate__party">
          {party == 'Republican' && (
            <PartyPill party={party} style={divStyle} />
          )}
          {party == 'Democrat' && <PartyPill party={party} style={divStyle} />}
        </td>
        <th class="candidate__cell candidate__name">
          {contestIsCalled && isWinner && contestResult != 'runoff' && (
            <span class={checkClass} style={checkStyle}>
              {checkmark}
            </span>
          )}
          {contestIsCalled && isWinner && contestResult == 'runoff' && (
            <span class={checkClass}>{checkmark}</span>
          )}
           {contestIsCalled && isWinner && isCanvass == true && contestResult != 'runoff' ? (
            <span class={checkClass}>{ballotName}</span>
          ) : (
            ballotName
          )}
          {IsAsterisk && <span class="asterisk">*</span>}{' '}
          {isIncumbent && (
            <span class="pill pill--basic" title="Currently holds this seat">
              Incumbent
            </span>
          )}
        </th>
        <td class="candidate__cell candidate__votes">{intcomma(votes)}</td>
        <td class="candidate__cell candidate__pct">
          {formatPercent(votes, totalVotesInContest)}
          <span class="candidate__pct-symbol">%</span>
        </td>
        {numDelegates && (
            <td class="candidate__cell candidate__votes">{numDelegates.find(cand => cand.candidate == ballotName)['delegate-count']}</td>
          )}
      </tr>
    );
  }
}

HeadshotCandidateRow.defaultProps = {
  isIncumbent: false,
  isCalled: false,
  isWinner: false,
  isViewable: true,
};

HeadshotCandidateRow.Header = (
  <thead>
    <tr>
      <th class="contest__candidate-header" colSpan={2}>
        Candidates
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Votes
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Pct.
        <span class="candidate__pct-symbol">%</span>
      </th>
    </tr>
  </thead>
);

HeadshotCandidateRow.Header_Prez = (
  <thead>
    <tr>
      <th class="contest__candidate-header" colSpan={2}>
        Candidates
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Votes
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Pct.
        <span class="candidate__pct-symbol">%</span>
      </th>
       <th class="contest__candidate-header contest__candidate-header--numeric">
           Delegates
          </th>
    </tr>
  </thead>
);

HeadshotCandidateRow.columnCount = 6;

export default HeadshotCandidateRow;